import React from "react";
import ScrollToTop from "react-scroll-up";
import { FiChevronUp } from "react-icons/fi";
import Helmet from "../component/common/Helmet";
import TextLoop from "react-text-loop";
import HeaderThree from "../component/header/HeaderThree";
import FooterTwo from "../component/footer/FooterTwo";
import TabTwo from "../elements/tab/TabTwo";
import ContactThree from "../elements/contact/ContactThree";
import ProjectList from "../elements/project/ProjectList";
import Portfolio from "../elements/portfolio/Portfolio";
import ServiceList from "../elements/service/ServiceList1";
import BlogContent from "../elements/blog/BlogContent";
import "./head.css";
import { Card, Col, Container, Row ,Button} from "react-bootstrap";
import pdf from "../component/header/Gaurav Rahangdale_Web developer_.pdf"

const SlideList = [
  {
    textPosition: "text-left",
    category: "",
    description: "",
    buttonText: "",
    buttonLink: "",
  },
];
const PortfolioLanding = () => {
  let title = "About Us",
    description =
      "DiGiLABS® is a web development cum digital services company that intends starting small in Lucknow but hopes to grow big in order to compete favorably with leading web development companies in the industry both in India and on a global stage";
  const PostList = BlogContent.slice(0, 3);
  return (
    <div className="active-dark">
      <div id="particles-js"></div>
      <Helmet pageTitle="Gaurav Rahangdale"/>
      <HeaderThree homeLink="/" logo="symbol-dark" color="color-black" />
      {/* Start Slider Area   */}
      <div id="home" className="fix">
        <div className="slider-wrapper">
          {/* Start Single Slide */}
          {SlideList.map((value, index) => (
            <div
              className="slide personal-portfolio-slider slider-paralax slider-style-3 d-flex align-items-center justify-content-center bg_image bg_image--25"
              key={index}
            >
              <div className="container name" >
                <div className="row">
                  <div className="col-lg-4" style={{ zIndex: "2" }}>
                    <div className={`inner ${value.textPosition}`}>
                      {value.category ? <span>{value.category}</span> : ""}
                      <h1 className="title" style={{ fontFamily: "Virgo 01" }}>
                        Gaurav Rahangdale <br />
                        <TextLoop>
                          <span> Web Developer,</span>
                          <span> Programmer,</span>
                          <span> Learner,</span>
                        </TextLoop>{" "}
                      </h1>
                      {value.description ? (
                        <p className="description">{value.description}</p>
                      ) : (
                        ""
                      )}
                      {value.buttonText ? (
                        <div className="slide-btn">
                          <a
                            className="rn-button-style--2 btn-primary-color"
                            href={`${value.buttonLink}`}
                          >
                            {value.buttonText}
                          </a>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
          {/* End Single Slide */}
        </div>
      </div>
      {/* End Slider Area   */}

      {/* Start About Area */}
      <Container style={{paddingTop:"33vh",paddingLeft:"0px"}} id="education">
           <Container style={{textAlign:"center"}}>
             <h2>education</h2>
           </Container>
           <Container>
             <Row>
               <Col style={{display:"flex",justifyContent:"center",paddingTop:"5vh"}}>
               <Card style={{ width: '20rem',backgroundColor:"#191919",color:"#989ba6",borderRadius:"20px" }} className="educard">
  <Card.Img  className="iimg" variant="top" src="https://cache.careers360.mobi/media/presets/720X480/colleges/social-media/media-gallery/2007/2018/10/5/Campus%20view%20of%20DY%20Patil%20College%20of%20Engineering%20and%20Technology_Campus-View.jpg"  width="120px" height="250px" style={{borderTopRightRadius:"20px",borderTopLeftRadius:"20px"}}/>
   <Container style={{position:"relative",top:"-20px",textAlign:"center"}}>
   <Button  className="button" style={{width:"100px"}}>UG</Button>
   </Container>
  <Card.Body>
    <p >
    D. Y. Patil College of Engineering and Technology, Kolhapur.
    </p>
    <p style={{fontWeight:"100",color:"#989ba6"}}>
      B.Tech - Computer Science
      <br/>
      2018-2022
    </p>
  </Card.Body>
</Card>

               </Col>

              <Col style={{display:"flex",justifyContent:"center",paddingTop:"5vh"}}>
              <Card style={{ width: '20rem',backgroundColor:"#191919",color:"#989ba6",borderRadius:"20px" }} className="educard" data-aos="zoom-in-up">
  <Card.Img className="iimg" variant="top" src="https://directory.edugorilla.com/wp-content/uploads/sites/6/2018/06/25129fce2be8039cba7226c1c3765a7c.jpeg"  width="120px" height="250px" style={{borderTopRightRadius:"20px",borderTopLeftRadius:"20px"}}/>
   <Container style={{position:"relative",top:"-20px",textAlign:"center"}}>
   <Button className="button" style={{width:"100px"}}>HSC</Button>
   </Container>
  <Card.Body>
    <p>
    Sunny's Spring Dale School,Bhandara
    </p>
    <p style={{fontWeight:"100"}}>
      <br/>
      2018
    </p>
  </Card.Body>
</Card>
              
              </Col>

              <Col style={{display:"flex",justifyContent:"center",paddingTop:"5vh"}}>
              <Card  style={{ width: '20rem',backgroundColor:"#191919",color:"#989ba6",borderRadius:"20px" }} className="educard">
  <Card.Img className="iimg" variant="top" src="https://s3mn.mnimgs.com/img/shared/school/459507/images/verified/459507.jpg"  width="120px" height="250px" style={{borderTopRightRadius:"20px",borderTopLeftRadius:"20px"}}/>
   <Container style={{position:"relative",top:"-20px",textAlign:"center"}}>
   <Button className="button" style={{width:"100px"}}>SSC</Button>
   </Container>
  <Card.Body>
    <p>
      Sunflag School, Bhandara
    </p>
    <p style={{fontWeight:"100"}}>
     <br/>
     <br/>
      2016
    </p>
  </Card.Body>
</Card>
              
              </Col>
             </Row>
           </Container>
      </Container>

      {/* End About Area */}

      {/* Start Service Area  */}
      <div id="skill" className="fix">
        <div className="service-area creative-service-wrapper ptb--120 bg_color--5">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="section-title text-center service-style--3 mb--30 mb_sm--0">
                  <h2 className="title">Skills</h2>
                </div>
              </div>
            </div>
            <div className="row creative-service">
              <div className="col-lg-12">
                <ServiceList
                  item="2"
                  column="col-lg-4 col-md-6 col-sm-6 col-12 text-left"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* End Service Area  */}
      {/* Added section */}

      {/* Start Portfolio Area */}
      

      {/* Start Portfolio Area */}
      <div className="portfolio-area ptb--120 bg_color--1" id="project" style={{backgroundColor:"#000"}}>
        <div className="portfolio-sacousel-inner mb--55">
          <Portfolio />
        </div>
      </div>
      {/* End Portfolio Area */}

      {/* Start Blog Area */}
      <div id="resume" className="fix">
        <div className="rn-blog-area ptb--120 bg_color--5 mb-dec--30">
          <div className="container">
            <div className="row align-items-end">
              <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                <div className="section-title text-center">
                  <h2>Resume</h2>
                </div>
              </div>
            </div>
             <Row style={{display:"flex",justifyContent:"center"}}> 
              <a href={pdf} download  data-aos="zoom-out">
                <button  className="rn-button-style--2 btn-solid"
                    
                      style={{ fontFamily: "QuickSand" ,marginTop:"5vh"}}>Download my Resume</button></a>
             </Row>
          </div>
        </div>
      </div>
      {/* End Blog Area */}

      {/* Start COntact Area */}
      {/* End COntact Area */}
      <FooterTwo />
      {/* Start Back To Top */}
      <div className="backto-top">
        <ScrollToTop showUnder={160}>
          <FiChevronUp />
        </ScrollToTop>
      </div>
      {/* End Back To Top */}
    </div>
  );
};

export default PortfolioLanding;
